export const PriceSlashData = [
  {
    img: "./images/phones/image 772.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 773.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "40%",
  },

  {
    img: "./images/phones/image 774.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 775.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 776.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "10%",
  },

  {
    img: "./images/phones/image 777.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },
];

export const PriceSlashDataI = [
  {
    img: "./images/phones/image 784.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 785.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "40%",
  },

  {
    img: "./images/phones/image 786.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 787.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 788.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 789.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "10%",
  },
];

export const PriceSlashDataII = [
  {
    img: "./images/phones/image 791.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 792.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "40%",
  },

  {
    img: "./images/phones/image 791.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 794.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 794.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 795.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "10%",
  },
];

export const PriceSlashDataIII = [
  {
    img: "./images/phones/image 797.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 798.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 799.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 800.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 801.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 796.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },
];

export const PriceSlashDataIV = [
  {
    img: "./images/phones/image 803.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 804.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 805.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 802.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 806.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 807.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },
];

export const PriceSlashDataV = [
  {
    img: "./images/phones/image 809.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 810.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 811.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 808.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 812.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },

  {
    img: "./images/phones/image 813.png",
    info: " Samsung Galaxy A50...",
    price: "₦ 100,000",
    slashed: 800000,
    percentage: "20%",
  },
];

export const OfficialStoreData = [
  {
    img: "./images/phones/Rectangle 2231.png",
    info: "IPHONES",
  },

  {
    img: "./images/phones/Rectangle 2233.png",
    info: "Andriod",
  },

  {
    img: "./images/phones/Rectangle 2235.png",
    info: "Basic Phone",
  },

  {
    img: "./images/phones/Rectangle 2232.png",
    info: "Ipads",
  },

  {
    img: "./images/phones/Rectangle 2234.png",
    info: "Tablets",
  },

  {
    img: "./images/phones/Rectangle 2236.png",
    info: "Education",
  },
];

export const OfficialStoreDataI = [
  {
    img: "./images/phones/Rectangle 2238.png",
    info: "IPHONES",
  },

  {
    img: "./images/phones/Rectangle 2239.png",
    info: "Andriod",
  },

  {
    img: "./images/phones/Rectangle 2240.png",
    info: "Basic Phone",
  },

  {
    img: "./images/phones/Rectangle 2241.png",
    info: "Ipads",
  },

  {
    img: "./images/phones/Rectangle 2242.png",
    info: "Tablets",
  },

  {
    img: "./images/phones/Rectangle 2243.png",
    info: "Education",
  },
];

export const OrderTableData = [
  {
    img: "./images/phones/R2 1.png",
    info: "IPHONES",
  },

  {
    img: "./images/phones/R2 1.png",
    info: "Andriod",
  },

  {
    img: "./images/phones/R6 1.png",
    info: "Basic Phone",
  },

  {
    img: "./images/phones/R4 1.png",
    info: "Ipads",
  },

  {
    img: "./images/phones/R5 1.png",
    info: "Tablets",
  },

  {
    img: "./images/phones/R3 1.png",
    info: "Education",
  },
];

export const OrderTableDataI = [
  {
    img: "./images/phones/Rectangle 2210.png",
    info: "IPHONES",
  },

  {
    img: "./images/phones/Rectangle 2212.png",
    info: "Andriod",
  },

  {
    img: "./images/phones/Rectangle 2214.png",
    info: "Basic Phone",
  },

  {
    img: "./images/phones/Rectangle 2211.png",
    info: "Ipads",
  },

  {
    img: "./images/phones/Rectangle 2213.png",
    info: "Tablets",
  },

  {
    img: "./images/phones/Rectangle 2215.png",
    info: "Education",
  },

  {
    img: "./images/phones/Rectangle 2216.png",
    info: "Education",
  },

  {
    img: "./images/phones/Rectangle 2218.png",
    info: "Education",
  },

  {
    img: "./images/phones/Rectangle 2220.png",
    info: "Education",
  },

  {
    img: "./images/phones/Rectangle 2217.png",
    info: "Education",
  },

  {
    img: "./images/phones/Rectangle 2219.png",
    info: "Education",
  },

  {
    img: "./images/phones/Rectangle 2221.png",
    info: "Education",
  },
];

export const OrderTableDataII = [
  {
    img: "./images/phones/Rectangle 2223.png",
    info: "IPHONES",
  },

  {
    img: "./images/phones/Rectangle 2224.png",
    info: "Andriod",
  },

  {
    img: "./images/phones/Rectangle 2225.png",
    info: "Basic Phone",
  },

  {
    img: "./images/phones/Rectangle 2226.png",
    info: "Ipads",
  },

  {
    img: "./images/phones/Rectangle 2227.png",
    info: "Tablets",
  },

  {
    img: "./images/phones/Rectangle 2228.png",
    info: "Education",
  },
];
export const bannerImage_PhoneTablet = [
  {
    bannerImage1: "./images/phones/2924 1.png",
    bannerImage2: "./images/phones/21914 1.png",
  },
];

export const bannerImage = [
  {
    bannerImage1: "./images/phones/2924 1.png",
    bannerImage2: "./images/phones/21914 1.png",
  },
];

export const ProductOrders = [
  {
  id: '19',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '20',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:3,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '21',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '22',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '23',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '24',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '25',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '26',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '27',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '28',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '29',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '30',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '31',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '32',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '33',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '34',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '35',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '36',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '37',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '38',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  mainPrice:'₦ 90,000',
  slashedPrice:'₦ 110,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '39',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '40',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:3,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '41',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '42',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '43',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '44',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '45',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '46',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '47',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '48',
  status: 'Available',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '49',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '50',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '51',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '52',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '53',
  status: 'Available',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '54',
  status: 'Available',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '55',
  status: 'Available',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '56',
  status: 'Available',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '57',
  status: 'Available',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
  mainPrice:45900,
  slashedPrice:800000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '58',
  status: 'Available',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  mainPrice:90000,
  detailedImages: {
    img1:
      "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
    img2:
      "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
  },
  slashedPrice:110000,
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
];

 